/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ValidationIssueResponseCategory = typeof ValidationIssueResponseCategory[keyof typeof ValidationIssueResponseCategory] | null;


export const ValidationIssueResponseCategory = {
  person: 'person',
  sender: 'sender',
  job: 'job',
  advanced: 'advanced',
  schedule: 'schedule',
  contact: 'contact',
  linkedin: 'linkedin',
  mailbox: 'mailbox',
  sequence: 'sequence',
  credit: 'credit',
  duplicate: 'duplicate',
  step_set: 'step_set',
} as const;
